import * as ActionPartnerTypes from '../actions/partner';
import * as ActionTypes  from '../actions';
import * as EventTypes  from '../actions/internal';
import * as UserTypes  from '../actions/users';
import { join, values, isEmpty, get } from 'lodash';
import { MSG_RESET_PASSWORD, MSG_CHANGE_PASSWORD, MSG_RESET_ADMIN_PASSWORD } from '../utils/messages';

const errorDefaultState = { message: null, messageType: 'alert', status: false };

const errorMessage = (state = errorDefaultState, action) => {
  switch (action.type) {
    case EventTypes.ERROR_MESSAGE:
    case ActionTypes.API_FAILURE: {
      const status = get(action.payload, 'status', 500);
      if (status === 429) {
        action.payload.previous = state;
        return state;
      }

      const { errors } = get(action.payload, 'response', action.payload) || {};
      return {
        message: !isEmpty(errors) ? join(values(errors), ', ') : get(action.payload, 'statusText') || get(action.payload, 'name', 'Unknown Error'),
        messageType: action.payload.messageType || 'alert',
        status: true,
      };
    }
    case ActionTypes.SIGN_OUT: {
      const { errors } = action.payload || {};
      return !isEmpty(errors) ? { message: join(values(errors), ','), messageType: 'alert', status: true } : errorDefaultState;
    }
    case ActionPartnerTypes.ACCOUNT_RESET_PASSWORD_RECEIVE:
      return { message: MSG_RESET_PASSWORD(action.meta.email), messageType: 'success', status: true };
    case EventTypes.RESET_ERROR_MESSAGE:
      if (action.meta.source === 'init' && state.messageType === 'warning') return state;
      return { message: null, messageType: 'alert', status: action.meta.status };
    case EventTypes.HIDE_MODAL:
      return errorDefaultState;
    case UserTypes.ADMIN_USER_UPDATE_RECEIVE:
      return { message: MSG_CHANGE_PASSWORD, messageType: 'success', status: true };
    case UserTypes.ADMIN_USER_RESET_PASSWORD_RECEIVE:
      return { message: MSG_RESET_ADMIN_PASSWORD, messageType: 'warning', status: true };
    case UserTypes.ADMIN_USER_CHANGE_PASSWORD_RECEIVE:
      return { message: MSG_CHANGE_PASSWORD, messageType: 'warning', status: true };
    case 'CUSTOM_MESSAGE':
      return { message: action.payload.message, messageType: action.payload.messageType, status: true };
    case 'CLEAR_MESSAGE':
      return { message: null, messageType: null, status: false };
    default:
      // if (/_RECEIVE$/.test(action.type)) return null;
      return state;
  }
}

export default errorMessage;
